var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-4"},[_c('CardProducto',{attrs:{"titulo":_vm.oferta.nombreCompleto,"rutaInferior":_vm.rutaInferior,"imageSrc":_vm.oferta.imagenUrl ? _vm.oferta.imagenUrl: '',"precio":_vm.precio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }